<template>
  <yd-table
    :data="complaintTableData"
    :loading="complaintLoading"
    element-loading-text="正在加载中～"
    max-height="400"
  >
    <template #tools>
      <span class="color-333 font-weight font-16">投诉情况</span>
    </template>
    <el-table-column align="center" prop="complaintNo" label="编号">
      <template slot-scope="{ row }">
        <span class="color-mainColor pointer" @click="handleDetail(row)">{{
          row.complaintNo
        }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" prop="orderNo" label="投诉订单" />
    <el-table-column align="center" prop="createTime" label="投诉时间" />
    <el-table-column
      align="center"
      prop="remark"
      label="投诉内容"
      width="200"
      show-overflow-tooltip
    />
    <el-table-column align="center" prop="statusName" label="处理状态" />
  </yd-table>
</template>

<script >
import { inject } from '@vue/composition-api';
const __sfc_main = {};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  const complaintTableData = inject('complaintTableData');
  const complaintLoading = inject('complaintLoading');
  const handleDetail = row => {
    emit('complaintDetai', row);
  };
  return {
    complaintTableData,
    complaintLoading,
    handleDetail
  };
};
export default __sfc_main;
</script>

<style lang="scss" scoped></style>
